import { createFileRoute, useLocation, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/u')({
  component: RouteComponent,
})

function RouteComponent() {
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname.includes('issues')) {
      navigate({ to: '/issues' })
    } else if (location.pathname.includes('manage')) {
      navigate({ to: '/manage' })
    } else {
      navigate({ to: '/orders' })
    }
  }, [location.pathname])

  return <div>{location.pathname}</div>
}
